import getEnvironDomain from 'utils/getEnvironDomain';
import axiosInstance from './axios';

async function searchGeoAPI(searchGeo) {
  const config = {
    method: 'POST',
    url: `https://${getEnvironDomain()}/gw/gis-dict/public/v1/autocomplete/suggestions`,
    data: searchGeo,
  };

  const res = await axiosInstance(config);
  return res.data;
}

export default searchGeoAPI;
